export enum OrderTypes {
  sales = 'SALES',
  quotation = 'QUOTATION',
  samples = 'SAMPLE',
  purchase = 'PURCHASE',
  relocate = 'RELOCATE',
  invoice = 'INVOICE',
}
